import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../Icons'
import TextField from '../../../FormLegacy/FormFieldsV2/TextField'

const CustomReplyWindow = ({ isOpen, onClose, data, onSelectAction }) => {
  const { t } = useTranslation(['chat'])
  const [search, setSearch] = useState('')

  const filteredData = data.filter((reply) => {
    const searchTerm = search.toLowerCase()
    const title = reply.title.toLowerCase()
    const message = reply.message.toLowerCase()
    return search ? title.includes(searchTerm) || message.includes(searchTerm) : true
  })

  if (!isOpen) return null
  return (
    <div className="custom-reply-window-container">
      <div className="custom-reply-window-background" />
      <div className="custom-reply-window-content-container">
        <div className="navbar-part">
          <h1>{t('chat:widgetCustomReplyWindow.title')}</h1>
          <div className="close-button" onClick={onClose}>
            <Icon icon="cross" />
          </div>
        </div>
        <TextField
          maxLength="50"
          name={'filter'}
          placeholder={t('chat:widgetCustomReplyWindow.searchReply')}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className="results-part">
          {filteredData.length
            ? filteredData.map((reply, idx) => (
                <div key={idx} className="reply-option" onClick={() => onSelectAction(reply)}>
                  <div className="reply-title">{reply.title}</div>
                  <div className="reply-message">{reply.message}</div>
                </div>
              ))
            : t('chat:searchAndSelectWindow.noResults')}
        </div>
      </div>
    </div>
  )
}

CustomReplyWindow.propTypes = {
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  data: PropTypes.array,
  onSelectAction: PropTypes.func,
}

export default CustomReplyWindow
